import instanceQuery from 'graphql/queries/product/ProductGlobalAmendQuery.graphql';
import defaultQuery from 'graphql/queries/product/ProductGlobalAmendDefault.graphql';
import mutationQuery from 'graphql/mutations/product/ProductGlobalAmendMutation.graphql';
import fragment from 'graphql/fragments/product/ProductGlobalAmendFragment.graphql';

const ProductGlobalAmend = {
  type: 'ProductGlobalAmend',
  title: 'Product Global Amendments',
  formTitle: 'Product Global Amendments',
  formUrl: '/Products/GlobalAmendments/',
  default: defaultQuery,
  instance: instanceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'PRODUCTS_GLOBAL_AMENDMENTS',
  resultUrl: '/Products/ProductGlobalAmendResultDetails/Workspace/',
};

export default ProductGlobalAmend;
